import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Privacy = () => {
  const [privacyContent, setPrivacyContent] = useState('');

  useEffect(() => {
    // Fetch data from the API
    fetch('https://dayoffice24.it/api/privacy-policy')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log(data); // Log the API response to check its format
        if (data.success && data.data && data.data.length > 0) {
          setPrivacyContent(data.data[0].description);
        } else {
          throw new Error('API returned an error: No privacy policy data found.');
        }
      })
      .catch((error) => {
        console.error('Error fetching privacy policy data:', error);
      });
  }, []);

  return (
    <div className="main_wrap">
      <Header />

      <div className="content-wrapper">
        <div className="breadcrumb-wrap bg-f br-2">
          <div className="container">
            <div className="breadcrumb-title text-center">
              <h2>Privacy Policy</h2>
              <ul className="breadcrumb-menu list-style">
                <li>
                 <Link to="/">Home</Link>
                </li>
                <li>Privacy Policy</li>
              </ul>
            </div>
          </div>
        </div>

        <section className="terms-wrap pt-100 pb-75 mb-10">
          <div className="container">
            <div className="row gx-5">
              <div className="col-lg-12">
                {privacyContent && (
                  <div dangerouslySetInnerHTML={{ __html: privacyContent }} />
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Privacy;
